export default "__VITE_ASSET__5a2b0128__"